import { ca } from "date-fns/locale";
import { diseaseAPI } from ".";
import {
  Recommendations,
  Score,
  VikritiRecommendations,
} from "../utils/interfaces";

export const getFormatttedPrakritiQuestions = async (email: string) => {
  try {
    const response = await diseaseAPI.getScoreQuestions(email, "Prakriti");
    if (response && response.length > 0) {
      let formattedQuestions: any[] = [];

      // Loop through the response and format each question
      response.forEach((prakritiRes: any) => {
        const prakritFields = {
          dependent_question_action:
            prakritiRes.attributes.dependent_question_action,
          dependent_question_id: prakritiRes.attributes.dependent_question_id,
          dependent_question_value:
            prakritiRes.attributes.dependent_question_value,
          is_sub_question: prakritiRes.attributes.is_sub_question,
          question_subcontent:
            prakritiRes.attributes.question_description ?? "",
          dosha: prakritiRes.attributes.dosha,
          sub_points: prakritiRes.attributes.sub_points,
          question_id: prakritiRes.attributes.question_id,
          question_type: prakritiRes.attributes.option_type,
          question_text: prakritiRes.attributes.question_text,
          question_values: prakritiRes.attributes.question_values,
          score_name: prakritiRes.attributes.score_name,
          question_description:
            prakritiRes.attributes.question_description ?? null,
        };

        // Push each question as an individual array inside the formattedQuestions array
        formattedQuestions.push(prakritFields);
      });

      // Return formatted questions
      return {
        questions: formattedQuestions,
      };
    } else {
      throw new Error("No Prakriti questions found");
    }
  } catch (err) {
    console.log("Error:", err);
    return null;
  }
};

export const getVikritiAnalysis = async (email: string) => {
  try {
    const response = await diseaseAPI.getVikritiAnalysis(
      `${email}@madmachines.in`
    );
    if (!response) {
      throw new Error("No Vikriti analysis found");
    }
    return response;
  } catch (err) {
    console.error("Error in getVikritiAnalysis:", err);
    throw new Error("Failed to fetch Vikriti analysis. Please try again.");
  }
};

const formatVikrutiType = (
  type: string,
  isScoreLabel: boolean = false
): string => {
  if (!isScoreLabel) {
    return type
      .split("_") // Split by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize
      .join(" "); // Join with a space
  } else {
    return type.split("_")[0].toUpperCase();
  }
};

export const getVikritiRecommendations = async (
  email: string
): Promise<Score> => {
  try {
    const response = await diseaseAPI.getVikritiRecommendation(
      `${email}@madmachines.in`
    );

    if (response) {
      const vikritiRecommendations: VikritiRecommendations = {
        all_unique_labels:
          response.all_unique_labels &&
          response.all_unique_labels !== "No recommendations"
            ? response.all_unique_labels
            : null,
        vikruti_type:
          response.vikruti_type &&
          response.vikruti_type !== "No recommendations"
            ? response.vikruti_type
            : null,
        prakriti_type:
          response.prakriti_type &&
          response.prakriti_type !== "No recommendations"
            ? response.prakriti_type
            : null,
        recommendation_type:
          response.recommendation_type &&
          response.recommendation_type !== "No recommendations"
            ? response.recommendation_type
            : null,
        recommendations:
          response.recommendations &&
          response.recommendations.length > 0 &&
          response.recommendations !== "No recommendations"
            ? response.recommendations
            : null,
      };

      return {
        label:
          response.vikruti_type &&
          response.vikruti_type !== "No recommendations"
            ? formatVikrutiType(response.vikruti_type)
            : "",
        max_score: 0, // Set defaults for irrelevant fields
        questions: [],
        score: 0,
        recommendations: {} as Recommendations,
        question_responses: [],
        score_label:
          response.vikruti_type &&
          response.vikruti_type !== "No recommendations"
            ? formatVikrutiType(response.vikruti_type, false)
            : "",
        vikrititRecomm: vikritiRecommendations,
      };
    } else {
      throw new Error("No Vikriti recommendations found");
    }
  } catch (err) {
    console.error("Error in getVikritiRecommendations:", err);
    throw new Error("Error in getVikritiRecommendations");
  }
};

export const fetchScoresAndVikriti = async (id: string) => {
  return await Promise.allSettled([
    diseaseAPI.getAllDisease(id),
    diseaseAPI.getAllScores(id),
    getVikritiRecommendations(id),
  ]);
};
